module.exports = __webpack_public_path__ + "static/img/4521_phase_function_Paper_PointsHejduk_Prediction.2597d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4521_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cENY
// module chunks = 0